import { GUID } from "app/brightserve/brightserve.module";

export class Contact {
	Id: GUID;
	Title: string;
	FirstName: string;
	LastName: string;
	Email: string;
	Phone: string;
	Avatar: number;
	ShiftStart: Date;
    ShiftEnd: Date;

	constructor(init?: Partial<Contact>){
		Object.assign(this, init);
	}

	Name() {
		return this.Title + " " + this.FirstName + " " + this.LastName;
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/contact.ts